import abbreviation from "./cs/abbreviation.json";
import action from "./cs/action.json";
import alert from "./cs/alert.json";
import confirm from "./cs/confirm.json";
import conjunction from "./cs/conjunction.json";
import enumValues from "./cs/enum.json";
import error from "./cs/error.json";
import event_description from "./cs/event_description.json";
import event_info from "./cs/event_info.json";
import help from "./cs/help.json";
import input from "./cs/input.json";
import label from "./cs/label.json";
import missing from "./cs/missing.json";
import notification from "./cs/notification.json";
import param_label from "./cs/param_label.json";
import param_text from "./cs/param_text.json";
import placeholder from "./cs/placeholder.json";
import question from "./cs/question.json";
import restriction from "./cs/restriction.json";
import sport_type from "./cs/sport_type.json";
import text from "./cs/text.json";
import validation from "./cs/validation.json";
import view from "./cs/view.json";
import map from "./cs/map.json";
import cookie_banner from "./cs/cookie_banner.json";

export default defineI18nLocale(() => {
    return {
    abbreviation: abbreviation,
    action: action,
    alert: alert,
    confirm: confirm,
    conjunction: conjunction,
    enum: enumValues,
    error: error,
    event_description: event_description,
    event_info: event_info,
    help: help,
    input: input,
    label: label,
    missing: missing,
    notification: notification,
    param_label: param_label,
    param_text: param_text,
    placeholder: placeholder,
    question: question,
    restriction: restriction,
    sport_type: sport_type,
    text: text,
    validation: validation,
    view: view,
    map: map,
    cookie_banner: cookie_banner,
    }
})
